<template>
  <div id="app">
  </div>
</template>
<script>
export default {
  created(){
    window.location.href="./account/login.html";
  },
  methods:{


  }

}
</script>
<style lang="less">

</style>
